import { view, utils } from '@yola/ws-sdk';
import controlUnits from '../constants/control-units';

const DEFAULT_BORDER_TOP_LEFT_RADIUS = '--ws-column-default-border-top-left-radius';
const DEFAULT_BORDER_TOP_RIGHT_RADIUS = '--ws-column-default-border-top-right-radius';
const DEFAULT_BORDER_BOTTOM_LEFT_RADIUS = '--ws-column-default-border-bottom-left-radius';
const DEFAULT_BORDER_BOTTOM_RIGHT_RADIUS = '--ws-column-default-border-bottom-right-radius';

const ATTRIBUTE_TO_CUSTOM_PROPERTY = {
  'border-top-left-radius': DEFAULT_BORDER_TOP_LEFT_RADIUS,
  'border-top-right-radius': DEFAULT_BORDER_TOP_RIGHT_RADIUS,
  'border-bottom-left-radius': DEFAULT_BORDER_BOTTOM_LEFT_RADIUS,
  'border-bottom-right-radius': DEFAULT_BORDER_BOTTOM_RIGHT_RADIUS,
};
const FALLBACK_VALUE = '4';

const computeCornersFallback = ({ elementId, attribute }) => {
  const element = view.accessors.getLiveElement(elementId);

  if (!element) return FALLBACK_VALUE;

  const defaultValue = getComputedStyle(element).getPropertyValue(
    ATTRIBUTE_TO_CUSTOM_PROPERTY[attribute]
  );

  if (!defaultValue) return FALLBACK_VALUE;

  const hasSupportedUnit = Object.values(controlUnits).some((unit) => defaultValue.endsWith(unit));

  if (!hasSupportedUnit) return FALLBACK_VALUE;

  const parsedValue = `${parseFloat(defaultValue)}`;

  return utils.isNumeric(parsedValue) ? parsedValue : FALLBACK_VALUE;
};

export default computeCornersFallback;
